import React from "react";
import Header from "../../../components/Header";
import { Tabs } from "antd";
import TabExamList from "./components/TabExamList";
import styles from "./index.module.scss";
import TabEvaluationList from "./components/TabEvaluationList";
import { RouteComponentProps, useHistory } from "react-router-dom";
import TabInvigilation from "./components/TabInvigilation";

interface PageParams {
    tab?: string;
}

export default function PageExamMain({
    match
}: RouteComponentProps<PageParams>) {
    const history = useHistory();

    return (
        <div className={styles.root}>
            <Header />

            <Tabs
                type="card"
                className={styles.tabs}
                animated={false}
                activeKey={match.params.tab || "list"}
                onChange={activeKey =>
                    history.replace(`/exam/main/${activeKey}`)
                }>
                <Tabs.TabPane key="list" tab="考核列表">
                    <TabExamList />
                </Tabs.TabPane>

                <Tabs.TabPane key="invigilation" tab="监考列表">
                    <TabInvigilation />
                </Tabs.TabPane>

                <Tabs.TabPane key="evaluation" tab="评卷列表">
                    <TabEvaluationList />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
}
